// extracted by mini-css-extract-plugin
export default {"wrapper":"zxAddOecTQosgkck3HUS","widthPlaceholder":"WhDFu7yRBi8MQQ3Tylse","input":"rsDG3WUFLX85dNPF2oCp"};